export const BetaFeatures = {
  POST_CHECKOUT_SUMMARY_RAVEN: 'POST_CHECKOUT_SUMMARY_RAVEN',
};
